<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import zhCN from "vue-easytable/libs/locale/lang/zh-CN";
 import {mapState,mapMutations,mapAction } from 'vuex'
export default {
  name: "app",
  mounted() {
    console.log(this.$refs.vetable)
    window.onresize = () => {
      return (() => {
          console.log("变化了")
           const windheight = window.innerHeight;
           this.getWindowHeight({windheight})

      })();
    };
    if (this._isMobile()) {
        // alert("手机端");
        localStorage.setItem('flagShow',1) ;
      }
  },
  created() {

    this.$veLocale.use(zhCN);
    const windheight = window.innerHeight;
   this.getWindowHeight({windheight})
  },
  methods: {
    ...mapMutations(['getWindowHeight']),
    _isMobile() {
    	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    	 return flag;
    }
  },
  components: {},
};
</script>

<style>
.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-body-tr td.ve-table-body-td, .ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-expand-tr td.ve-table-body-td{
padding: 5px 0 !important;
}
.el-message-box {
    width: 80% !important;
}
.ve-dropdown-popper {
    z-index: 2200 !important;
}
#app{
 /* overflow-y:auto; */
  --bg-color : orange; 
  --font-color:#fff
}
.empty-data {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 400px;
        width: 100%;
        color: #666;
        font-size: 16px;
        border: 1px solid #eee;
        border-top: 0;
    }
.table-pagination {
        margin-top: 20px;
        text-align: center;
    }
.el-descriptions :not(.is-bordered) .el-descriptions-item__cell{
  padding: 10px;
}
* {
  box-sizing: border-box;

  padding: 0;

  margin: 0;
}
html {
  margin: 0;

  height: 100%;

  width: 100%;
}
#app {
  height: 100%;

  width: 100%;
  /* overflow-y: hidden; */
}
#WHnum {
  width: 100%;
  height: 100%;
}
.tablemain {
  width: 97%;
  height: 90%;
  margin: 1% auto;
  overflow: hidden;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.1);
}
.expandFrom {
  padding: 10px 40px;
}
.tablecss {
  width: 100%;
  /* height: 100%; */
   padding: 10px;
    /* height: calc(100% - 30px);  */
  overflow: hidden;
}
.el-table {
  font-size: 12px !important;
}
.el-table .cell {
  line-height: 14px !important;
}
.tablecss /deep/ .el-table .cell {
    overflow: hidden;
    text-decoration: solid;
    padding: 0 !important;
    max-height:100px;
    line-height: 24px !important
  }
  .tablecss /deep/ .el-table .el-table__cell{
    padding:0;
  }
  .el-table .el-table__cell{
    overflow: hidden;
    text-decoration: solid;
    padding: 0 !important;
    max-height:100px;
    line-height: 24px !important
  }
  .tablecss /deep/ .el-pagination__total{
    margin-left: 30%;
  }
  .ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content thead.ve-table-header tr.ve-table-header-tr th.ve-table-header-th{
    padding: 0px !important;
  }


</style>
